export enum MeasurementSystem {
  Metric = 'Metric',
  Imperial = 'Imperial',
}

export const lengthMeasurement = (system: MeasurementSystem) => (system === MeasurementSystem.Metric ? 'cm' : 'inches');
export const weightMeasurement = (system: MeasurementSystem) => (system === MeasurementSystem.Metric ? 'kg' : 'pounds');
